import { useEffect, useState } from 'react';
import siteConfig from '../config/siteConfig';

const { cookieConsent } = siteConfig;
const consentKey = cookieConsent?.storageKey || 'cookie_consent';

const styles = {
  container: {
    position: 'fixed',
    bottom: 16,
    left: 16,
    right: 16,
    maxWidth: 560,
    margin: '0 auto',
    zIndex: 9999,
    background: '#0b1c3d',
    color: '#fff',
    padding: '16px 18px',
    borderRadius: 10,
    boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
    display: 'flex',
    alignItems: 'flex-start',
    gap: 12,
    flexWrap: 'wrap',
  },
  text: { flex: 1, fontSize: 14, lineHeight: 1.4, margin: 0 },
  link: { color: '#9ad0ff', textDecoration: 'underline' },
  actions: { display: 'flex', gap: 10 },
  btnPrimary: {
    background: '#4caf50',
    border: 'none',
    color: '#fff',
    padding: '8px 12px',
    borderRadius: 8,
    cursor: 'pointer',
    fontWeight: 600,
  },
  btnSecondary: {
    background: 'transparent',
    border: '1px solid rgba(255,255,255,0.4)',
    color: '#fff',
    padding: '8px 12px',
    borderRadius: 8,
    cursor: 'pointer',
    fontWeight: 600,
  },
};

export default function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(consentKey);
    if (consent !== 'accepted' && consent !== 'declined') {
      setIsVisible(true);
    }
  }, []);

  const setConsent = (value) => {
    localStorage.setItem(consentKey, value);
    document.dispatchEvent(new CustomEvent('cookie-consent', { detail: value }));
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div style={styles.container} role="status" aria-live="polite">
      <p style={styles.text}>
        We use cookies and similar tech for analytics to improve your experience.{' '}
        <a href={cookieConsent?.policyUrl || '/privacy'} style={styles.link}>
          Learn more
        </a>
        .
      </p>
      <div style={styles.actions}>
        <button type="button" style={styles.btnSecondary} onClick={() => setConsent('declined')}>
          Decline
        </button>
        <button type="button" style={styles.btnPrimary} onClick={() => setConsent('accepted')}>
          Accept
        </button>
      </div>
    </div>
  );
}
